import { BaseElementWithoutShadowDOM } from '@theme/base-element'

export class ComponentProductRecommendations extends BaseElementWithoutShadowDOM {
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties)

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        rootMargin: '0px 0px 200px 0px',
      }
    )
    this.observer.observe(this)
  }
  handleIntersection(entries, observer) {
    const entry = entries[0]
    if (!entry.isIntersecting) return

    observer.unobserve(this)

    const url = this.dataset.url

    if (url) {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('.product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch((e) => {
          console.error('Failed to fetch recommendations:', e)
        })
    }
  }
}

customElements.define(
  'product-recommendations',
  ComponentProductRecommendations
)
